<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Sessions" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <!-- <Filter
        :stateProp="stateList"
        @filterHandle="filterHandle"
        :hasCustomDate="true"
        :hasPeriod="false"
        :hasLocation="true"
        :hasCharger="true"
        :applyMPs="true"
        :periodNameProp="`Current MP`"
      /> -->
      <div class="px-2">
      <FilterS3
        :hasCharger="true"
        :stateProp="stateList"
        :periodNameProp="`Current MP`"
        :showRefreshButton="showSessionRefreshButton"
        :refreshing="refreshingSessionCache"
        :refreshDisabled="!isValidMpId(filter.mp_id) || refreshingSessionCache"
        :updatedAt="sessionCacheUpdatedAt"
        @filterHandle="filterHandle"
        @refreshCache="refreshSessionListCache"
        ref="filterRefS3"
       />
      </div>
      <el-row 
        class="m-0 width-100-p mt-3"
        v-if="!showBarChart">
        <!-- Abatement -->
        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 16 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Sessions</h5>
            </el-col>
            <!-- Abatement Chart -->
            <el-col
              :span="24"
              v-loading="loadingChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart" v-if="!showBarChart">
                <apexchart
                  :key="firstChartKey"
                  ref="chart"
                  type="bar"
                  height="350"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </el-col>
          </div>
        </el-col>
        <!-- History -->
        <el-col
          class="d-flex align-item-center"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-2' : ''"
        >
          <div class="row m-0 width-100-p">
            <el-col
             :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mb-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
                v-loading="loadingCard"
                :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50"
                element-loading-background="rgba(122, 122, 122, 0.8)"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_sessions == null
                            ? 0
                            : sessionCardData.total_sessions.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total number of sessions
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                <div class="width-80 height-80">
                  <svg>
                    <use href="@/assets/svg/icon-sprite.svg#session-num-sessions-80"></use>
                  </svg>
                </div>
                </el-col>
              </div>
            </el-col>
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mt-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
                v-loading="loadingCard"
                :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50"
                element-loading-background="rgba(122, 122, 122, 0.8)"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_usage == null
                            ? 0
                            : sessionCardData.total_usage.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total usage (MWh)
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <div class="width-80 height-80">
                    <svg>
                      <use href="@/assets/svg/icon-sprite.svg#avoided-fossil-fuel-icon"></use>
                    </svg>
                  </div>
                </el-col>
              </div>
            </el-col>
          </div>
        </el-col>
      </el-row>
      <el-row class="m-0 width-100-p mt-3"
        v-if="showBarChart">
        <!-- Abatement -->

        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 16 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 v-if="selectedTable == 'unallocatedSessions'" class="text-white mt-3 ml-1">Unallocated Sessions Group {{this.groupBy[this.selectedGroupBy]}}</h5>
              <h5 v-if="selectedTable == 'sessions'" class="text-white mt-3 ml-1">Sessions Group {{this.groupBy[this.selectedGroupBy]}}</h5>
            </el-col>
           
            <el-col
              :span="24"
              v-loading="loadingBarChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart">
                <apexchart
                  :key="barChartKey"
                  ref="chart"
                  type="bar"
                  height="350"
                  :options="chartOptionsTwo"
                  :series="seriesTwo"
                ></apexchart>
              </div>


            </el-col>
              <!-- pagination button for chart two -->
              <el-col
                :span="12"
                class="d-flex align-items-center justify-content-start"
                v-if="showPaginationButton"
              >
                <div class="pagination" >
                  <el-button class="height-40 border-color-light rounded-3 width-100-p mr-1" @click="prevPage" :disabled="currentPage === 0">Previous</el-button>
                  <el-button class="height-40 border-color-light rounded-3 width-100-p mr-1" @click="nextPage" :disabled="(currentPage + 1) * pageSize >= largeDataset.length">Next Page</el-button>
                </div>
              </el-col>
              <el-col :span="12" class="d-flex align-items-center justify-content-end mt-3" v-if="showPaginationButton">
                <span class="text-white">
                  {{ (currentPage) * pageSize + 1 }}-{{
                    ((currentPage ) * pageSize + (pageSize)) > totalDataPoints ? totalDataPoints : (currentPage ) * pageSize + (pageSize)
                  }}
                  of {{ totalDataPoints }}
              </span>
              </el-col>
          </div>
        </el-col>

        <el-col
          class="d-flex align-item-center"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-2' : ''"
        >
          <div class="row m-0 width-100-p">
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mb-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-10' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
                v-loading="loadingCard"
                :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50"
                element-loading-background="rgba(122, 122, 122, 0.8)"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_sessions == null
                            ? 0
                            : sessionCardData.total_sessions.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total number of sessions
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="
                      require('@/assets/images/dashboard/home/FuelAvoided.png')
                    "
                    fit="cover"
                  />
                </el-col>
              </div>
            </el-col>
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mt-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-10' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
                v-loading="loadingCard"
                :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50"
                element-loading-background="rgba(122, 122, 122, 0.8)"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_usage == null
                            ? 0
                            : sessionCardData.total_usage.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total usage (MWh)
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="
                      require('@/assets/images/dashboard/home/FuelAvoided.png')
                    "
                    fit="cover"
                  />
                </el-col>
              </div>
            </el-col>
          </div>
        </el-col>


      </el-row>
      <el-row class="m-0 width-100-p mt-3">
        <el-col class="d-flex align-item-center px-2" :span="24">
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <SessionTable
                ref="sessionTable"
                :filterProp="filter"
                @changeTab="changeTab"
                @cardLoadingChange="cardLoadingChange"
                @sessionDataToParent="sessionDataToParent"
                @selectedTableFromChild="selectedTableFromChild"
                @tableAction="handleTableAction"
                @cacheUpdatedAt="onCardCacheUpdatedAt"
                />
            </div>
          </div>
        </el-col>
      </el-row>


    </div>

  </div>
</template>

<script>
// import Filter from "../common/filter.vue";
import FilterS3 from "../common/filter-s3.vue";
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import { sessionChart, sessionChartTwo } from "./config.js";
import UserService from "../../../services/user.service";
import SessionTable from "./sessionTable.vue";
import { addTaskIdtoSessionStorage, createCeleryTaskPoller } from "../common/pollingCeleryTask";
export default {
  props: {},
  components: {
    SessionTable,
    FilterS3,
  },
  data() {
    return {
      // check which table is showing
      selectedTable: "sessions",

      
      selectedPeriod: "All",
      series: sessionChart.series,
      chartOptions: sessionChart.chartOptions,

      seriesTwo: sessionChartTwo.series,
      chartOptionsTwo: sessionChartTwo.chartOptions,
      sumTotalUsage: 0,

      sessionCardData: {
        total_sessions: 0,
        total_usage: 0,
      }, // total number of sessions
      
      states: [],
      filter: {
        country: "",
        elec_region: "",
        startDate: "2024-01-01 00:00:00",
        endDate: "2024-12-31 23:59:59",
      },
      SessionData: [],
      pendingSessionData: [],

      childSessionData: [],
      childPendingSessionData: [],

      loading: false,
      refreshingSessionCache: false,
      dashboardCacheUpdatedAt: "",
      cardCacheUpdatedAt: "",
      loadingCard: false,
      loadingChart: false,

      firstChartKey: 0,


      loadingBarChart: false,
      showBarChart: false,
      selectedGroupBy: "",
      OthersCount: 0,
      totalCount: 0,
      barChartKey: 0,
      groupBy: {
        1: "All",
        2: "By Region",
        3: "By Charger",
        4: "By site",
        5: "By Error",
      },

      // pagination for chart two
      largeDataset: [], 
      categoryLabels: [],
      totalDataPoints: 5000,
      pageSize: 25,
      currentPage: 0,
      paginatedChartOptions: {},
      paginatedSeries: [],
      showPaginationButton: false,
    };
  },
  watch: {
    selectedTable: function (val) {
      console.log("selectedTable : ", val);
      console.log("selectedGroupBy : ", this.selectedGroupBy);

      if(val == "unallocatedSessions") {
        this.series[0].data = [];
        this.series[1].data = [];
        this.chartOptions.labels = [];
        this.firstChartKey += 1;
      }
      else if(val == "sessions") {
        if(this.SessionData != null && this.SessionData.total_count != null) {
          this.fillChargerByState();
        } else {
          this.applyFilterS3();
        }
      }
      else {
        return;
      }
    },

    "childSessionData": function (val) {
      if(val.selectedGroupBy == 1) {
        this.showBarChart = false;
        return;
      }
      else if(val.sessionDataList.length > 0) {
       
        this.loadBarChartData(val.sessionDataList);
        this.totalCount = val.totalCount;
        this.sumTotalUsage = val.totalUsage;
        this.selectedGroupBy = val.selectedGroupBy;
      } else {
        // refresh chart when no data
        this.chartOptionsTwo.labels = [];
        this.chartOptionsTwo.xaxis.categories = [];
        this.seriesTwo[0].data = [];
        this.showBarChart = true;
        this.barChartKey += 1;
        this.loadingBarChart = false;
      }

    },

    "filter.customer_id": function(val) {
      console.log("filter.customer_id : ", val);
      if(val == "") {
        this.filter.customer_id = null;
      }
    },

    SessionData: {
      
      
      handler(val) {
        console.log("val data", val);
        if (val == null || val.total_count == null) {
          return;
        } else {
          this.fillChargerByState();
        }
      },
      deep: true,
    },

    series: {
      handler() {
        this.updatefirstChartKey();
        this.loadingChart = false;
      },
      deep: true,
    },




    // "SessionData": function(val) {
    //   if(val == null || val.total_count == null) {
    //     return;
    //   } else {
    //     this.fillChargerByState();
    //   }
    // },

    // pagination for chart two
    paginatedData: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    paginatedLabels: {
      handler: "handlePaginatedLabels",
      immediate: true,
    },
  },
  computed: {
    isAdminUser() {
      return this.$store.state.auth.user != null && this.$store.state.auth.user.is_admin;
    },
    showSessionRefreshButton() {
      return this.isAdminUser && this.isValidMpId(this.filter.mp_id);
    },
    isOverallSessionView() {
      const hasValue = (value) => value != null && String(value).trim() !== "";
      return (
        this.isValidMpId(this.filter.mp_id) &&
        !hasValue(this.filter.customer_id) &&
        !hasValue(this.filter.elec_region) &&
        !hasValue(this.filter.country) &&
        !hasValue(this.filter.charger_name)
      );
    },
    sessionCacheUpdatedAt() {
      if (!this.isOverallSessionView || this.selectedTable === "invalidSessions") {
        return "";
      }
      const cardUpdatedAt = this.cardCacheUpdatedAt;
      if (!cardUpdatedAt) {
        return "";
      }
      if (this.showBarChart || this.selectedTable !== "sessions") {
        return cardUpdatedAt;
      }
      const dashboardUpdatedAt = this.dashboardCacheUpdatedAt;
      if (!dashboardUpdatedAt) {
        return "";
      }
      const cardTime = Date.parse(cardUpdatedAt);
      const dashboardTime = Date.parse(dashboardUpdatedAt);
      if (Number.isNaN(cardTime) || Number.isNaN(dashboardTime)) {
        return cardUpdatedAt;
      }
      return cardTime >= dashboardTime ? cardUpdatedAt : dashboardUpdatedAt;
    },
    stateList() {
      return this.states;
    },

    // pagination for chart two
    paginatedData() {
      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;
      return this.largeDataset.slice(start, end);
    },

    paginatedLabels() {
      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;
      return this.categoryLabels.slice(start, end);
    },

  },

  async mounted() {
    // console.log(this.$store.state.auth.user);
    // await this.fetchData();

    // pagination for chart two
    for (let i = 1; i <= this.totalDataPoints; i++) {
      this.categoryLabels.push(`Category ${i}`);
      this.largeDataset.push(Math.floor(Math.random() * 100) + 1);
    }
  },
  methods: {
    /** Call FilterS3's applyFilter() via ref */
    applyFilterS3() {
      this.$refs.filterRefS3?.applyFilter();
    },
    updatefirstChartKey() {
      this.firstChartKey += 1;
    },  
    
    // pagination for chart two
    // updata chart labels with paginated labels
    handlePaginatedLabels() {
      this.barChartKey += 1;
      this.chartOptionsTwo.xaxis.categories = this.paginatedLabels;
    },

    // update chart series data with paginated data
    handlePaginatedData() {
      this.seriesTwo[0].data = this.paginatedData;
      this.loadingBarChart = false;
    },

    // pagination for chart two change page button
    nextPage() {
      if ((this.currentPage + 1) * this.pageSize < this.largeDataset.length) this.currentPage++;
    },

    prevPage() {
      if (this.currentPage > 0) this.currentPage--;
    },


    fillForm() {
      this.fillChargerByState();
    },

    /**
     * Load the chart data based on the session data.
     * updates the chart labels and series data with the session count
     * 
     */
    fillChargerByState() {
      this.loadingChart = true;
      this.series[0].data = [];
      this.series[1].data = [];
      this.chartOptions.labels = [];
      this.SessionData.sessions.forEach((value) => {
        this.chartOptions.labels.push(value.group_by.toString());
        this.series[0].data.push(value.count_session);
        this.series[1].data.push(value.sum_usage);
      });
      
    },



  /**
   * Fetches session data from the server based on the current filter settings.
   * Endpoint: api/dashboard-session-data
   * 
   */
    isValidMpId(mpId) {
      return mpId != null && mpId !== "" && Number.isFinite(Number(mpId));
    },

    onCardCacheUpdatedAt(updatedAt) {
      this.cardCacheUpdatedAt = updatedAt || "";
    },

    async refreshSessionListCache() {
      if (!this.isValidMpId(this.filter.mp_id)) {
        this.$message.warning("Select a monitoring period to refresh data.");
        return;
      }
      this.refreshingSessionCache = true;
      try {
        await UserService.ClearSessionListCache({
          mp_id: this.filter.mp_id,
        });
        const table = this.$refs.sessionTable;
        if (table && typeof table.handleRefresh === "function") {
          if (typeof table.cancelSessionRequest === "function") {
            table.cancelSessionRequest();
          }
          table.handleRefresh();
        }
        await this.fetchData();
      } catch (error) {
        const apiMessage = error.response && error.response.data && error.response.data.message;
        this.$message.error(apiMessage || error.message || "Failed to refresh data.");
      } finally {
        this.refreshingSessionCache = false;
      }
    },

    async fetchData() {      
      console.log("fetchData: filter", this.filter);
      let body = null;
      body = {
        start_date: this.filter.startDate,
        end_date: this.filter.endDate,
        customer_id: this.filter.customer_id,
        charger_name: this.filter.charger_name,
        country: this.filter.country || "",
        elec_region: this.filter.elec_region || "",
        mp_id: this.filter.mp_id ?? null,
      };
      await UserService.DashboardSessionsData(body)
        .then(
          (response) => {
            this.dashboardCacheUpdatedAt = response?.data?.updated_at || "";
            this.states = (response.data.data.session_by_state || []).map(
              (session) => session.elec_region || session.state
            );
            
            this.SessionData = response.data.data.session_data;

            // this.fillForm();
          },
          (error) => {
            this.loading = false;
            this.dashboardCacheUpdatedAt = "";
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          this.dashboardCacheUpdatedAt = "";
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    filterHandle(event) {
      // console.log("Charger : ", event);
      if(this.selectedTable == "sessions") {
        this.filter = event;
        this.fetchData();
      }
      else if(this.selectedTable == "unallocatedSessions") {
        this.filter = event;
      }

      // console.log("Filter : ", this.filter);
    },

    // receive data from child component | used in sessionTable | update card data when tab is changed
    changeTab(event) {
      this.sessionCardData.total_sessions = event.total_sessions ?? event.total_count ?? 0;
      this.sessionCardData.total_usage = event.total_usage ?? 0;

    },

    cardLoadingChange(event) {
      this.loadingCard = event;
    },

    // receive data from child component | used in sessionBarCharts
    sessionDataToParent(event) {
      this.childSessionData = event;
      // console.log("Session Data : ", this.childSessionData);
    },

    selectedTableFromChild(event) {
      console.log("selectedTableFromChild : ", event);
      this.selectedTable = event;
    },

    // load group by data to chart two 
    loadBarChartData(val) {
      this.showBarChart = true;
      this.loadingBarChart = true;

      // sort data by count_session
      const data = val.sort((a, b) => b.count_session - a.count_session);

      this.currentPage = 0; // reset pagination
      this.barChartKey += 1; // reset chart 
      
      let series = [];
      let labels = [];

      let labelMapping = {
        "Session outside the current monitoring period.": "Outside monitoring period",
        "Charger was excluded at the time the sessions were received.": "Charger excluded",
        "Duplicate in database: Exact match with an existing session": "Duplicate: Exact match",
        "Duplicate in database: start and end time, and charger information duplicate": "Duplicate: start, end time & charger",
        "Duplicate in database: start time, usage, and charger information duplicate": "Duplicate: start time, usage & charger",
        "Duplicate in database: end time, usage, and charger information duplicate": "Duplicate: end time, usage & charger",
        "Duplicate in the new data: start and end time, and charger information duplicate with other rows": "Duplicate: start, end time & charger",
        "Undefined site name": "Undefined site name",
        "Undefined charger id": "Undefined charger id",
        "Undefined port id": "Undefined port id",
        "Capacity mismatch between session data and charger schedule": "Capacity mismatch",
        "Postcode mismatch between session data and charger schedule": "Postcode mismatch",
        "Max power above 1.05 charger capacity": "Above charger capacity",
        "Usage is zero or negative": "Zero or negative usage",
        "Start time is the same or after the end time": "Start time >= end time",
        "Long session (longer than 48 hours (DC charger) or 72 hours (AC charger))": "Long session",
        "Session with a usage above the usage limit per session": "Over consumption per session",
        "Session before operational date of the charger": "Before operational date",
        "Max power above 1.05 port capacity": "Above port capacity",
        "Session after sold date": "After sold date",
        "Charger added to the project after the start time of the session": "Charger added after session",
        "Operational date of charger before 23 September 2017": "Installed before Sep 2017",
      }


      
      // pagination for chart two start
      this.totalDataPoints = data.length;
      if(this.totalDataPoints > this.pageSize) {
        this.showPaginationButton = true;
      } else {
        this.showPaginationButton = false;
      }

      // add series and labels
      data.forEach((value) => {
          series.push(value.count_session);
          labels.push(value.group_by == null ? "null" : labelMapping[value.group_by] || value.group_by);
          });

      // load data to chart two
      this.largeDataset = series;
      this.categoryLabels = labels;


    },

    handleTableAction(event) {
      if (event.kind !== "showAbatementCalDetails" || !event.data) return;
      const request = {
        ...event.data,
        start_date: this.filter.startDate,
        end_date: this.filter.endDate,
        mp_id: this.filter.mp_id ?? event.data.mp_id,
      };
      const start_date = this.filter.startDate;
      const end_date = this.filter.endDate;
      const status = request.status || this.filter.status;
      const allowedStatus = ["current", "revision_under_audit", "revision_issue_requested"];

      UserService.getSessionsForAbatementCalculation(request)
        .then((response) => {
          const raw = response?.data?.data ?? response?.data ?? response;
          const list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
          const row = list[0];
          if (!row) {
            this.$message?.info("No data to display.");
            return;
          }
          const customerFullName = row.full_name?.full_name ?? row.customer_full_name ?? row.customer_name ?? row.customer ?? "";
          const totalSessions = row.total_sessions ?? row.total_count ?? "";
          const withAbatement = row.sessions_with_abatement ?? row.with_abatement ?? "";
          const withoutAbatement = row.sessions_without_abatement ?? row.without_abatement ?? "";
          const startDate = start_date ?? "";
          const endDate = end_date ?? "";
          const chargerName = request.charger_name || null;
          const siteName = request.site_name || null;
          const message = `
            <div style="text-align: left;">
              <p><strong>Customer full name:</strong> ${this.escapeHtml(customerFullName)}</p>
              <p><strong>Site name:</strong> ${this.escapeHtml(String(siteName ?? ""))}</p>
              <p><strong>Charger name:</strong> ${this.escapeHtml(String(chargerName ?? ""))}</p>
              <p><strong>Start date:</strong> ${this.escapeHtml(String(startDate))}</p>
              <p><strong>End date:</strong> ${this.escapeHtml(String(endDate))}</p><br>
              <p><strong>MP Status:</strong> ${this.escapeHtml(String(status ?? ""))}</p><br>
              <p><strong>Total sessions:</strong> ${this.escapeHtml(String(totalSessions))}</p>
              <p><strong>Sessions with abatement:</strong> ${this.escapeHtml(String(withAbatement))}</p>
              <p><strong>Sessions without abatement:</strong> ${this.escapeHtml(String(withoutAbatement))}</p>
              <br>
              <p><strong>Do you want to recalculate the abatement for total of ${totalSessions} sessions?</strong></p>
              <p><strong>This action cannot be undone!</strong></p>
            </div>
          `;
          ElMessageBox.confirm(message, "Confirm Abatement calculation details", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          })
            .then(() => {
              if (status && !allowedStatus.includes(status)) {
                useToast().error("This monitoring period is not allowed for abatement calculation. Please select a valid monitoring period.", {
                  icon: "fa fa-times",
                  position: "bottom-right",
                  timeout: 2000,
                });
                return null;
              }
              const abatementFilter = {
                customer_id: request.customer_id,
                reset_abatement: true,
                charger_name: chargerName,
                site_name: siteName,
                mp_id: request.mp_id,
              };
              return UserService.AbatementCalculate(abatementFilter);
            })
            .then((response) => {
              if (response == null) return;
              useToast().success(
                "The abatement calculation job has been submitted. Please allow a few minutes for the portal to update.",
                {
                  icon: "fa fa-check",
                  position: "bottom-right",
                  timeout: 2000,
                }
              );
              const task_id = response.data.task_id;
              addTaskIdtoSessionStorage("abatement_calculate", task_id, "PENDING", "message", {
                success_message: "The abatement calculation job is successfully completed.",
                error_message: "The abatement calculation job has failed. Please try again.",
              });
              const poller = createCeleryTaskPoller(task_id, 30000, "abatement_calculate");
              poller.startPolling();
            })
            .catch((err) => {
              if (err !== "cancel" && err?.response?.status === 401) {
                this.$router.push({ path: "/" });
              } else if (err?.response?.data?.code == 1001) {
                useToast().error(err?.response?.data?.message || "The operation has occurred an error.", {
                  icon: "fa fa-times",
                  position: "bottom-right",
                  timeout: 2000,
                });
              } else if (err !== "cancel") {
                useToast().error(err?.message || "The operation has occurred an error.", {
                  icon: "fa fa-times",
                  position: "bottom-right",
                  timeout: 2000,
                });
              }
            });
        })
        .catch((err) => {
          // console.error("getSessionsForAbatementCalculation", err);
          this.$message?.error(err?.message || "Failed to load abatement details.");
        });
    },
    escapeHtml(str) {
      const div = document.createElement("div");
      div.textContent = str;
      return div.innerHTML;
    },
  },
};
</script>

<style scoped>

.pagination {
  margin-top: 10px;
  margin-bottom: 15px;
}
.pagination > .el-button {
  margin: 5px;
  padding: 10px;
  cursor: pointer;
}

</style>